import { render, staticRenderFns } from "./VideoFrame.vue?vue&type=template&id=a0878f3a&"
import script from "./VideoFrame.vue?vue&type=script&lang=js&"
export * from "./VideoFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports